import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-wharehouse-order-sale-searial2',
  templateUrl: './wharehouse-order-sale-searial2.component.html',
  styleUrls: ['./wharehouse-order-sale-searial2.component.scss']
})
export class WharehouseOrderSaleSearial2Component implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public readonly: boolean = false;
  public list_select_items_length: number = 0;
  public list_record: any = [];
  public list_searial: any = [];
  public list_select_items: any = [];
  public order_buy_id!: number;
  public list_selected_searial: any = [];
  public searial_used: any = [];
  public user_id!: number;
  public searial_selected: any = [];
  public title!: string;
  public order_id!: number;
  public index!: number;
  public subscription: Subscription | any;
  public server!: any;
  public token!: any;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public matDialogRef: MatDialogRef<WharehouseOrderSaleSearial2Component>,
    public matSnackBar: MatSnackBar
    ,) {
    this.server = this.serverService.get_server();
    if (dialog_data) {
      if (dialog_data.readonly) this.readonly = dialog_data.readonly;
      this.order_id = dialog_data.id;
      this.order_buy_id = dialog_data.order_buy_id;
      this.title = dialog_data.title;
      this.token = dialog_data.token;
      this.searial_selected = dialog_data.searial_selected;
      if (this.searial_selected) {
        if (typeof this.searial_selected == 'object') {
          //alert(1)
        }
        else {
          //alert(2);
        }
      }
      else {
        //alert(3)
      }
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_data();
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 6678,
      order_id: this.order_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.list_selected_searial = res['result'][0].wharehouse_order_searial;
            this.list_select_items = res['result'][0].wharehouse_order_searial;
          }
          this.get_searial2(this.order_buy_id);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_searial2(id: number) {
    var selected_array: any = [];
    if (this.list_selected_searial) {
      selected_array = this.list_selected_searial.split(",").map((items) => {
        return parseInt(items);
      });
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6673, order_id: id }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (selected_array.indexOf(res['result'][i].wharehouse_order_sale_searial_id) != -1) {
              res['result'][i].checked = true;
            }
            var searial_selected = [];
            if (this.searial_selected) {

            }
            this.list_record.push(res['result'][i]);
          }//end for
          this.get_consumeed_searial();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_consumeed_searial() {
    var obj = {
      address: 7219,
      order_buy_id: this.order_buy_id,
      id: this.order_id,
      token: this.token
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['result'][0].wharehouse_order_searial) {
              this.searial_used = res['result'][0].wharehouse_order_searial.split(",").map((items: any) => {
                return parseInt(items)
              });
            }
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //********************************************************* */
  select_items(type: number) {
    this.list_select_items = [];
    var list_select_items_temp = <any>document.getElementsByName("searial[]");
    for (var i = 0; i < list_select_items_temp.length; i++) {
      if (list_select_items_temp[i].checked == true) {
        this.list_select_items.push(list_select_items_temp[i].value);
      }
      this.list_select_items = this.list_select_items.map(function (items) {
        return parseInt(items);
      })
    }
    if (type == 2) {
      this.matDialogRef.close({ list_select_items: this.list_select_items });
    }
  }
  //********************************************************************************************************** */
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
